import {Component, OnInit} from '@angular/core'
import {AngularFirestore} from 'angularfire2/firestore'
import {Router, ActivatedRoute} from '@angular/router'
import {BrandService} from './brand.service'

const BRANDCOLLECTION = 'brands'
const PROJECTCOLLECTION = 'projects'

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  providers: [BrandService],
  styleUrls: ['./brand.component.scss'],
})
export class BrandComponent implements OnInit {
  brand: any
  projects: any = []
  projects_client: any = []
  projects_brand: any = []
  newProjectId: string

  constructor(
    private firestore: AngularFirestore,
    public router: Router,
    public route: ActivatedRoute,
    public brandService: BrandService
  ) {}

  ngOnInit() {
    this.newProjectId = this.firestore
      .collection(PROJECTCOLLECTION)
      .ref.doc().id
    this.route.params.subscribe(({brandId}) => {
      this.firestore
        .doc([BRANDCOLLECTION, brandId].join('/'))
        .valueChanges()
        .subscribe(brand => {
          this.brand = brand
          this.brandService.setBranding(brandId)
        })

      this.firestore
        .collection(PROJECTCOLLECTION, ref =>
          ref.where('client', '==', brandId)
        )
        .valueChanges()
        .subscribe(projects => {
          this.projects_client = projects.map(project => {
            project['brand'] = this.brandService.getBrand(project['brand'])
            project['client'] = this.brandService.getBrand(project['client'])
            return project
          })
          this.projects = this.projects_client.concat(this.projects_brand)
        })

      this.firestore
        .collection(PROJECTCOLLECTION, ref => ref.where('brand', '==', brandId))
        .valueChanges()
        .subscribe(projects => {
          this.projects_brand = projects.map(project => {
            project['brand'] = this.brandService.getBrand(project['brand'])
            project['client'] = this.brandService.getBrand(project['client'])
            return project
          })
          this.projects = this.projects_client.concat(this.projects_brand)
        })
    })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/brand/brand.component.ts